import React from 'react';
import {Space} from 'antd';
import {observer} from "mobx-react";
import {useFetcher} from "react-router-dom";
import * as Role from "../index";

export const EntityTranslate: React.FC = observer(() => {
    const fetcher = useFetcher<any>();

    const onSubmit = (values: any) => {
        fetcher.submit(values, { method: "post" })
    }

    return (
        <Space direction="vertical" size="small" style={{ display: 'flex' }}>
            <Role.EntityTranslateForm onSubmit={onSubmit} />
        </Space>
    )
})